import { Button, StandardDialog } from '@roc/ui';
import CreatePostClosingCondition from './createPostClosingCondition';
import { CreatePostClosingConditionStore } from 'libs/feature-documents/src/documents/stores/documentForms/postClosingCondition/createPostClosingConditionStore';

type CreatePostClosingConditionDialogProps = {
  store: CreatePostClosingConditionStore;
  open: boolean;
  taskId: number;
  taskTitle: string;
  onClose: () => void;
  onSuccess: () => void;
};

export const CreatePostClosingConditionDialog = ({
  store,
  open,
  taskId,
  taskTitle,
  onClose,
  onSuccess,
}: CreatePostClosingConditionDialogProps) => {

  const onSubmit = async () => {
    store.submit(taskId, taskTitle, onSuccess);
  };

  return (
    <StandardDialog
      open={open}
      handleClose={onClose}
      title="Create Post-Closing Condition"
      dialogContent={<CreatePostClosingCondition store={store} />}
      maxWidth="md"
      dialogActions={
        <>
          <Button
            style={{ marginRight: '8px' }}
            onClick={onClose}
            color="primary"
            variant="outlined"
            testId="cancel"
          >
            Close
          </Button>
          <Button
            onClick={onSubmit}
            color="primary"
            variant="contained"
            testId="save"
            disabled={false}
          >
            Save
          </Button>
        </>
      }
    />
  );
};

export default CreatePostClosingConditionDialog;
